import { FormatPrice, Text } from '@reveni-io/reveni-ui'

import { getSignedAmount, hasConceptError } from '@/returns/helpers/helpers'

import * as Styles from './styles'

const RefundSummary = ({ selectedConcepts, currency, extraAmount, extraLabel, showExtra }) => {
  let concepts = [...selectedConcepts]

  if (showExtra) {
    concepts = [...concepts, { id: extraLabel, label: extraLabel, amount: extraAmount }]
  }

  if (!concepts.length) return null

  return (
    <Styles.Container>
      {concepts.map(concept => (
        <Styles.RefundConceptContainer key={concept.id} hasError={hasConceptError(concept)}>
          <Text type="bodyMRegular">{concept.label}</Text>
          <Text type="bodyMRegular">
            <FormatPrice currency={currency}>{getSignedAmount(concept)}</FormatPrice>
          </Text>
        </Styles.RefundConceptContainer>
      ))}
    </Styles.Container>
  )
}

export default RefundSummary
